import styled from 'styled-components';
import { darkgrey, lightGrey } from 'styles/Colors';

export const NoteDescription = styled.div`
  color: ${lightGrey};
  font-family: Lato;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 18.2px;
  margin-bottom: 12px;
`;

export const Headline = styled.div`
  color: ${darkgrey};
  font-family: Lato;
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 25.2px;
`;
